
export default {
  page: {
    background: '#f2e6df'
  },
  main: {
    color: '#bf4545',
  },
  estimatedDeliveryDateOrStatus: {
    fontFamily: '"Playfair Display", sans-serif',
    fontWeight: '400',
    fontSize: '34px',
    lineHeight: '40px'
  },
  signatureRequired: {
    background: '#fdd8cf',
    color: '#222222'
  },
  auctaneBrand: {
    color: '#929292'
  },
  custom1: {  // layout01 card
    boxShadow: '-9px 9px 0 #eed9d3'
  },
  custom2: {  // layout01 card header
    color: '#767676'
  }
};